<template>
  <v-card-actions>
    <v-spacer />
    <span class="mr-2">{{ __('total') }}</span>
    <span class="font-weight-medium">{{ $store.state.cashControl.form.total | currency }}</span>
  </v-card-actions>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],
  }
</script>
